export const createArray = (len) => {
    return Array.from({ length: len }, (_, i) => i + 1);
}

export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const subBefore = (str, searchTerm) => {
    let substr = '';
    if (searchTerm) {
        let indexOfFirst = str.indexOf(searchTerm);
        substr = str.substring(0, indexOfFirst);
    }
    return substr;
}

export const subAfter = (str, searchTerm) => {
    let substr = '';
    if (searchTerm) {
        let indexOfFirst = str.indexOf(searchTerm);
        substr = str.substring(indexOfFirst + searchTerm.length);
    }
    return substr;
}